<template>
  <div v-if="sanitized" v-html="sanitized" data-translate-skip></div>
</template>

<script lang="ts">
import store from "@/general/store";
import commons from "@/common/store/modules/commons";
import { Options, Vue } from 'vue-class-component';
import sanitizeHTML from "sanitize-html";

@Options({
  store: store,
  props: {
    text: { type: String, required: true }
  }
})
export default class TextSanitized extends Vue {
  text!: string;
  get colorCode() {
    return commons.colorCode;
  }

  get sanitized() {
    const result = sanitizeHTML(this.getText, {
      allowedTags: sanitizeHTML.defaults.allowedTags.concat(["img"]),
      allowedAttributes: {
        "*": ["style"],
        a: ["href", "target"],
        img: ["src"]
      },
      selfClosing: [
        "img",
        "br",
        "hr",
        "area",
        "base",
        "basefont",
        "input",
        "link",
        "meta"
      ],
      // URL schemes we permit
      allowedSchemes: ["http", "https"],
      allowedSchemesByTag: { img: ["http", "https", "data"] },
      allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
      transformTags: {
        a: sanitizeHTML.simpleTransform("a", {
          style: `color: ${this.colorCode}`
        }),
        em: sanitizeHTML.simpleTransform("em", {
          style: "font-style: italic"
        }),
        i: sanitizeHTML.simpleTransform("i", {
          style: "font-style: italic"
        })
      }
    });
    return result;
  }

  get getText() {
    return this.text;
  }
}
</script>
